import React from 'react';
import { ButtonPrimary, dlsColorWarning, IconWarning } from '@americanexpress/dls-react';
import PropTypes from 'prop-types';
import { routes } from '../../constants/paths';
import labels from '../../constants/labels';
import useAutoLogout from '../../hooks/useAutoLogout';

const ErrorMessage = ({ location }) => {
  const customMessage = location?.state?.errorMessage;
  // Generic CTA: callers control the label and where it navigates. Defaults keep
  // a "Try Again" button that returns home.
  const buttonLabel = location?.state?.buttonLabel || 'Try Again';
  const buttonHref = location?.state?.buttonHref || routes.home;

  // When the CTA is a logout URL, silently log the user out after 10 seconds.
  useAutoLogout(buttonHref);

  const onNavigation = () => {
    window.location.assign(buttonHref);
  };

  return (
    <div className="border text-align-center pad-3-tb" role="alert">
      <div className="pad-responsive-lr stack">
        <IconWarning id="icon-warning" size="xl" theme={dlsColorWarning} />
        <h1 className="heading-4 margin-1-b">{'We\'re sorry, but it looks like something went wrong.'}</h1>
        <p className="body-3">{customMessage || labels.AMEX_REP_HELP_MESSAGE}</p>
      </div>
      <hr className="margin-3-tb" />
      <ButtonPrimary onClick={onNavigation}>{buttonLabel}</ButtonPrimary>
    </div>
  );
};

ErrorMessage.propTypes = {
  location: PropTypes.shape({
    state: PropTypes.shape({
      errorMessage: PropTypes.string,
      buttonLabel: PropTypes.string,
      buttonHref: PropTypes.string,
    }),
  }),
};

ErrorMessage.defaultProps = {
  location: undefined,
};

export default ErrorMessage;
